import React from 'react'
import './warning.css'
import gifWarningDarkMode from './img/gifWarningDarkMode.2gif.gif'
import { BsFillSunFill } from 'react-icons/bs';

export default function WarningDarkMode({darkMode, setDarkMode}) {

    if (darkMode === true) {
        document.body.classList.add('no-scroll');
    } else {
        document.body.classList.remove('no-scroll');
    }

    return (
        <>
        {darkMode ? (
            <div className="container_popup_warning">
            <div className="popup_warning">
            <span className='popup_warning_subtitle'>Dark-Mode</span>
            <h2 className='popup_warning_title'>Warning</h2>
                <BsFillSunFill onClick={() => {
                    setDarkMode(!darkMode)}}
                    className='warning_back_to_light_mode' 
                    alt='close pop up warning'/>
                <div className="warning_content">
                    <p>Aw, sorry ): but the dark mode design hasn't been completed yet...</p>
                    <img className='WarningDarkModeGIF' src={gifWarningDarkMode} alt="Cute Anime GIF" />
                    <p id='warning_content_explain'>I chose to implement a switch between light and dark mode and to keep the transition and animation on even if isn't ready yet because i wanna that users can see that the process of adapting a dark mode to the page is a plan and is in progress. I hope you enjoy the other features and explore the site sections to get to know me better (: Thank you in advance.</p>
                    <span>Note: To switch back to light mode, please click on the sun icon in the upper right corner.</span>
                </div>
            </div>
        </div>
        ): ''}  
    </>
    )
}
